export const a11yRoles = {
    button: 'button'
};